import {useEffect, useState} from "react"
import httpReq from "../services/httpReq"
import {Box, Button, Chip, Toolbar, Typography} from "@mui/material"
import {ActionsToolBar} from "../components/grid/ActionsToolbar"
import * as _ from 'lodash'
import {AgGridReact} from "ag-grid-react"
import AddIcon from '@mui/icons-material/Add'
import ModalAddTag from "../components/modals/tags/ModalAddTag"
import ModalEditTag from "../components/modals/tags/ModalEditTag"
import HomeMadeDialog from "../components/dialogs/HomeMadeDialog"
import HomeMadeSnackbar from "../components/snackbars/HomeMadeSnackbar"
import FullPageLoader from "../components/loaders/FullPageLoader"
import useMobile from "../hooks/useMobile";
import * as lod from 'lodash'

const TagsPage = () => {
    const isMobile = useMobile();

    const ValuesCount = (props) => {
        const length = (props.value ?? []).length
        return (
            <Chip label={length}></Chip>
        )
    }

    const ToolBar = (props) => {
        let selectedRow = props.node.data;
        const editAction = () => {
            setRowToEdit(selectedRow)
            setIsModalEditOpen(true)
        };

        const deleteAction = () => {
            setRowToDelete(selectedRow)
            setIsOpenDeleteDialog(true)
        };

        // type is up or down
        const upTag = () => {
            const s = {...selectedRow}
            if (s.orderIndex > 0) {
                updateRowsData(s, 'up')
            }
        }

        const downTag = () => {
            const s = {...selectedRow}
            updateRowsData(s, 'down')
        }

        const customActions = [
            {
                action: upTag,
                disabled: false,
                icon: 'arrow-up',
                label: 'Move up tag',
                tooltip: 'Move up tag'
            },
            {
                action: downTag,
                disabled: false,
                icon: 'arrow-down',
                label: 'Move down tag',
                tooltip: 'Move down tag'
            }
        ];
        return <ActionsToolBar customActions={customActions} hasEdit editAction={editAction} hasDelete
                               deleteAction={deleteAction}/>;
    };
    const HasDefaultValueRender = (props) => {
     
        const findIfHasDefaultValue = props.data.values.find(v => v.isDefault)
        return (
            <>
                {findIfHasDefaultValue ?
                    <Chip icon={
                        findIfHasDefaultValue.fileSrc &&
                        <img
                            src={findIfHasDefaultValue.fileSrc}
                            alt="icon"
                            style={{width: 24, height: 24, borderRadius: '50%'}}
                        />
                    } label={findIfHasDefaultValue.value} sx={{
                        backgroundColor: findIfHasDefaultValue.color,
                        minWidth: !isMobile ? 100 : 80,
                        color: 'white'
                    }}></Chip>
                    :
                    <Box sx={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%'}}>

                    </Box>
                }
            </>
        )
    }
    const [rowsData, setRowsData] = useState([])
    const colsLabel = [
        {
            field: 'name'
            , headerName: 'Name'
            , flex: 2
        },
        {headerName: 'Default value', cellRenderer: HasDefaultValueRender, flex: !isMobile ? 1 : 2},
        {headerName: 'Values', field: 'values', cellRenderer: ValuesCount, flex: !isMobile ? 1 : 2},
        {headerName: 'Order', field: 'orderIndex', flex: !isMobile ? 1 : 2},
        {headerName: 'Actions', cellRenderer: ToolBar, flex: !isMobile ? 1 : 2}
    ]
    const [isModalAddOpen, setIsModalAddOpen] = useState(false)
    const [isModalEditOpen, setIsModalEditOpen] = useState(false)
    const [rowToEdit, setRowToEdit] = useState(null)
    const [rowToDelete, setRowToDelete] = useState(null)
    const [isOpenDeleteDialog, setIsOpenDeleteDialog] = useState(false)
    const [isOpenSnackbar, setisOpenSnackbar] = useState(false)
    const [snackbarValues, setSnackbarValues] = useState({
        btnColor: '',
        color: '',
        closeAction: true,
        message: ''
    })
    const [isLoading, setIsLoading] = useState(false)

    const updateRowsData = async (selectedRow, type) => {
        const r = [...rowsData]
        const idx = r.findIndex(e => e.name === selectedRow.name)
        const a = type === 'up' ? 1 : -1
        if (r[idx] && r[idx - a]) {
            r[idx].orderIndex -= a;
            r[idx - a].orderIndex += a;
            const rowsToSave = _.sortBy(r, ['orderIndex'], 'desc')
            setRowsData(rowsToSave)
            //
            const promiseRowsData = rowsData.map(async (data) => {
                const res = await httpReq(`Tag/Update`, 'PATCH', data, true)
                if(!res || res.responseAnyError) return;
                if (!res.responseAnyError) {
                    return res
                }
            })
            await Promise.all(promiseRowsData)
        }

    }

    const deleteTag = async () => {
        const res = await httpReq(`Tag/Delete/${rowToDelete.id}`, 'DELETE', null, true)
        if(!res || res.responseAnyError) return;
        if (!res.responseAnyError) {
            const v = [...rowsData]
            const idx = v.findIndex(a => a.id === res.responseData.id)
            v.splice(idx, 1)
            setIsOpenDeleteDialog(false)
            setRowsData(v)
            setRowToDelete(null)
            setSnackbarValues({
                btnColor: 'white',
                closeAction: true,
                color: 'green',
                message: 'Tag successfully deleted'
            })
            setisOpenSnackbar(true)
        } else {
            setSnackbarValues({
                btnColor: 'white',
                closeAction: true,
                color: 'red',
                message: res.responseMessage
            })
            setisOpenSnackbar(true)
        }
    }

    useEffect(() => {
        // Make the POST request to the server
        httpReq('Tag/GetList', 'GET', null, true)
            .then(res => {
                if(!res || res.responseAnyError) return;
                const newTags = [...res.responseData].map((item) => {
                    item.open = true;
                    item.values = item.values.map((value) => {
                        value.isLoading = false;
                        value.isLoaded = false;
                        return value;
                    });
                    return item;
                });
                 const v = [...lod.orderBy(newTags, ['orderIndex'], 'asc')]
                setRowsData(v);
            });
    }, [isModalAddOpen, isModalEditOpen]);


    const updateLoading = (tagIndex, tagValueIndex, isLoading) => {
        const newTags = [...rowsData];
        const tagValues = [...newTags[tagIndex].values];
        tagValues[tagValueIndex].isLoading = isLoading;
        newTags[tagIndex].values = tagValues;
        setRowsData(newTags);
    }

    const updateLoaded = (tagIndex, tagValueIndex, isLoading) => {
        const newTags = [...rowsData];
        const tagValues = [...newTags[tagIndex].values];
        tagValues[tagValueIndex].isLoaded = isLoading;
        newTags[tagIndex].values = tagValues;
        setRowsData(newTags);
    }

    const updateImage = (tagIndex, tagValueIndex, fileSrc) => {
        const newTags = [...rowsData];
        const tagValues = [...newTags[tagIndex].values];
        tagValues[tagValueIndex].fileSrc = fileSrc;
        newTags[tagIndex].values = tagValues;
        setRowsData(newTags);
    }

    useEffect(() => {
        rowsData.forEach((tag, tagIndex) => {
            const values = tag.values;
            values.forEach((value, tagValueIndex) => {
                if (value.isLoaded === false && value.isLoading === false && value.fileContent === '') {
                    updateLoading(tagIndex, tagValueIndex, true);
                    httpReq('TagValue/Get/' + value.id, 'GET', null, true)
                        .then(res => {
                            if(!res || res.responseAnyError) return;
                            const tagValue = res.responseData;
                            if (tagValue.fileContent) {
                                const fileSrc = "data:" + tagValue.fileMimeType + ";base64," + tagValue.fileContent;

                                updateImage(tagIndex, tagValueIndex, fileSrc);
                            }

                            updateLoading(tagIndex, tagValueIndex, false);
                            updateLoaded(tagIndex, tagValueIndex, true);
                        });
                }
            })
        })

    }, [rowsData])


    const getTagsList = async () => {
        setIsLoading(true)
        const res = await httpReq('Tag/GetList', 'GET', null, true)
        if(!res || res.responseAnyError) return;
        if (!res.responseAnyError) {
            const data = res.responseData
            const dt = _.sortBy(data, ['orderIndex'], 'desc')
            const dtValuesMap = dt.map(async tag => {
                const values = tag.values
                const defaultValue = values.find(v => v.isDefault)
                if (defaultValue) {
                    const resSingleValue = await httpReq('TagValue/Get/' + defaultValue.id, 'GET', null, true)
                    if (!resSingleValue.responseAnyError) {
                        const data = resSingleValue.responseData;
                        if (data.fileContent && data.fileContent !== '') {
                            const fileExtension = data.fileExtension
                            const fileExtensionSplit = fileExtension.split('.')
                            const base64 = `data:${data.fileMimeType}/${fileExtensionSplit[1]};base64,${data.fileContent}`
                            data.base64 = base64
                        }
                        tag.defaultValue = data
                    }
                }
                /*
                const mappedValues = values.map(async value => {
                  const resSingleValue = await httpReq('TagValue/Get/' + value.id, 'GET', null, true)

                    const data = resSingleValue.responseData;

                    if(data.fileContent && data.fileContent !== ''){
                    const fileExtension = data.fileExtension
                    const fileExtensionSplit = fileExtension.split('.')
                    const base64 = `data:${data.fileMimeType}/${fileExtensionSplit[1]};base64,${data.fileContent}`
                    data.base64 = base64

                    }
                    return data
                  }
                })
                */
                // const a = await Promise.all(mappedValues)
                // tag.values = a
                return tag
            })
            const pool = await Promise.all(dtValuesMap)
            setRowsData(pool)
            setIsLoading(false)
        }
    }


    return (
        <>
            <Box sx={{display: 'flex', flexDirection: 'column', height: '100%'}}>
                <Toolbar sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                    <Typography sx={{flex: 1, fontSize: 15, fontWeight: 700}}>Tag list</Typography>
                    <Button onClick={() => setIsModalAddOpen(true)} variant='contained'
                            sx={{borderRadius: '4px !important', display: 'flex', flexDirection: 'row', gap: 2}}>
                        <AddIcon/>
                    </Button>
                </Toolbar>
                {!isOpenDeleteDialog &&
                    <div style={{margin: 10, height: '100%'}}>
                        <AgGridReact
                            rowData={rowsData}
                            columnDefs={colsLabel}
                        />
                    </div>
                }
            </Box>
            {isModalAddOpen && <ModalAddTag isMobile={isMobile} isModalAddOpen={isModalAddOpen}
                                            setIsModalAddOpen={setIsModalAddOpen}/>}
            {isModalEditOpen && <ModalEditTag isModalEditOpen={isModalEditOpen} setIsModalEditOpen={setIsModalEditOpen}
                                              rowToEdit={rowToEdit} isMobile={isMobile}/>}
            {isOpenDeleteDialog && <HomeMadeDialog
                fnClose={() => setIsOpenDeleteDialog(false)}
                isOpen={isOpenDeleteDialog}
                labelClose={'Close'}
                text={'Are you sure?'}
                title={`Delete tag ${rowToDelete.name}`}
                fnConfirmAction={() => deleteTag()}
                labelConfirm={'Confirm'}/>}
            {isOpenSnackbar &&
                <HomeMadeSnackbar
                    btnColor={snackbarValues.btnColor}
                    closeAction={snackbarValues.closeAction}
                    color={snackbarValues.color}
                    message={snackbarValues.message}
                    setIsOpen={setisOpenSnackbar}

                />
            }
            {isLoading && <FullPageLoader/>}
        </>
    )
}
export default TagsPage